import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: false,
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  fa: any;
  sideMenu: any = [
    { title: 'Operations', path: '' },
    { title: 'Dashboard', path: '/app/dashboard', icon: 'bi bi-speedometer2' },
    { title: 'Customers', path: '/app/customers', icon: 'bi bi-people' },
    { title: 'Transactions', path: '/app/transactions', icon: 'bi bi-database' },
    { title: 'Reconciliation', path: '/app/reconciliation', icon: 'bi bi-book' },
    { title: 'Ledgers', path: '/app/ledgers', icon: 'bi bi-book' },
    { title: 'Rate Conversion', path: '/app/rate-conversion', icon: 'bi bi-calculator' },
    { title: 'Beneficiaries', path: '/app/beneficiaries', icon: 'bi bi-book' },
    { title: 'Settlement', path: '/app/settlement', icon: 'bi bi-cash-stack' },
    { title: 'Admin', path: '' },
    { title: 'Users', path: '/app/users', icon: 'bi bi-people' },
    { title: 'Security Questions', path: '/app/security-questions', icon: 'bi bi-question-circle' },
  ];
  activeUrl = '';
  pageTitle = 'Dashboard';
  user: any;
  menuOpen = true;
  isMobile = false;
  private readonly mobileBreakpoint = 768;

  constructor(
    private _router: Router,
    private _auth: AuthService
  ) {
    const vm = this;
    vm.isMobile = vm.isMobileWidth();
    vm.menuOpen = !vm.isMobile;
    vm._router.events.subscribe((res: any) => {
      vm.activeUrl = vm._router.url;
      if (res instanceof NavigationEnd && vm.isMobile) {
        vm.menuOpen = false;
      }
    });

  }

  ngOnInit(): void {
    const vm = this;
    vm.user = vm._auth.getUser();
  }

  toggleMenu() {
    const vm = this;
    vm.menuOpen = !vm.menuOpen;
  }

  closeMenu() {
    const vm = this;
    vm.menuOpen = false;
  }

  @HostListener('window:resize')
  onResize() {
    const vm = this;
    const isMobile = vm.isMobileWidth();
    if (isMobile !== vm.isMobile) {
      vm.isMobile = isMobile;
      vm.menuOpen = !isMobile;
    }
  }

  private isMobileWidth(): boolean {
    const vm = this;
    return window.innerWidth < vm.mobileBreakpoint;
  }

  onLogout() {
    const vm = this;
    vm._auth.logout();
  }

}